import { render, staticRenderFns } from "./authenticationTest.vue?vue&type=template&id=60d59c2c&scoped=true"
import script from "./authenticationTest.vue?vue&type=script&lang=js"
export * from "./authenticationTest.vue?vue&type=script&lang=js"
import style0 from "./authenticationTest.vue?vue&type=style&index=0&id=60d59c2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d59c2c",
  null
  
)

export default component.exports